import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const ModalConfirm = ({ open, title, message, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={(e, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      onCancel();
    }} disableEscapeKeyDown>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Annulla
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirm; 